import { render, staticRenderFns } from "./ProjectObjectList.vue?vue&type=template&id=8f8b9f92&scoped=true&"
import script from "./ProjectObjectList.vue?vue&type=script&lang=js&"
export * from "./ProjectObjectList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectObjectList.vue?vue&type=style&index=0&id=8f8b9f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8b9f92",
  null
  
)

export default component.exports